var _path, _rect, _rect2, _rect3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClinicalTrials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    viewBox: "0 0 26 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,0H1C.45,0,0,.45,0,1v30c0,.55.45,1,1,1h23c1.1,0,2-.9,2-2V2c0-1.1-.9-2-2-2ZM2,2h2v28h-2V2ZM24,30H6V2h18v28Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    width: 8,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    width: 2,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 2,
    height: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16c0,.55.45,1,1,1h8c.55,0,1-.45,1-1,0-2.41-1.33-3.93-2.58-4.84.95-.73,1.58-1.87,1.58-3.16,0-2.21-1.79-4-4-4s-4,1.79-4,4c0,1.29.62,2.43,1.58,3.16-1.25.91-2.58,2.43-2.58,4.84ZM15,6c1.1,0,2,.9,2,2s-.9,2-2,2-2-.9-2-2,.9-2,2-2ZM15,12.07c.69.29,2.38,1.17,2.87,2.93h-5.74c.49-1.79,2.18-2.65,2.87-2.93Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalTrials);
export default __webpack_public_path__ + "static/media/clinical-trials.be23e059fc6291b06d39b6047c418abc.svg";
export { ForwardRef as ReactComponent };